import React from "react";

const Stepper = ({ label, value, min, onChange, note }) => (
    <div className="productdisplay-right-size">
        <h1>{label}</h1>
        <div className="productdisplay-stepper">
            <button type="button" className="productdisplay-stepper-btn" onClick={() => onChange(Math.max(min, value - 1))}>-</button>
            <span className="productdisplay-stepper-value">{value}</span>
            <button type="button" className="productdisplay-stepper-btn" onClick={() => onChange(value + 1)}>+</button>
        </div>
        {note && <p className="productdisplay-stepper-note">{note}</p>}
    </div>
);

export default Stepper;
